import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import NotesHeader from '../components/notes/NotesHeader';
import PublicNotesHeader from '../components/notes/PublicNotesHeader';
import PublicNotesList from '../components/notes/PublicNotesList';
import PublicNotesPagination from '../components/notes/PublicNotesPagination';
import UserNotesList from '../components/notes/UserNotesList';
import UserNotesPagination from '../components/notes/UserNotesPagination';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageTitle from '../components/shared/page/PageTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';
import Tabs from '../components/shared/tabs/Tabs';
import { ROLE_VEHICLE_MANAGER } from '../redux/constants/rolesConstants';

const Notes = () => {
  const readOnly = !useSelector((state) => state.auth?.userData?.roles.includes(ROLE_VEHICLE_MANAGER));

  const tabs = [
    {
      label: 'МОЇ НОТАТКИ',
      content: (
        <div className="mt-6 flex flex-col gap-3 md:gap-8 bg-white">
          <NotesHeader readOnly={readOnly} />
          <UserNotesList readOnly={readOnly} />
          <UserNotesPagination />
        </div>
      ),
    },
    {
      label: 'ПУБЛІЧНІ',
      content: (
        <div className="mt-6 flex flex-col gap-3 md:gap-8 bg-white">
          <PublicNotesHeader />
          <PublicNotesList />
          <PublicNotesPagination />
        </div>
      ),
    },
  ];

  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <PageTitle title={'Нотатки'} />
        </PageTitleContainer>
        <Container>
          <Tabs className="mt-0" tabs={tabs} />
        </Container>
      </section>
    </Suspense>
  );
};

export default Notes;
